module.exports = __webpack_public_path__ + "static/media/warning-delete.33357364.svg";